import React from 'react';
import { Box } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const DragHandle = ({ attributes, listeners, isDragging }) => {
  return (
    <Box
      {...attributes}
      {...listeners}
      sx={{
        cursor: isDragging ? 'grabbing' : 'grab',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isDragging ? 'primary.main' : 'text.secondary',
        '&:hover': {
          color: 'primary.main'
        },
        touchAction: 'none',
        userSelect: 'none'
      }}
    >
      <DragIndicatorIcon />
    </Box>
  );
};

export default DragHandle;
